module.exports = __webpack_public_path__ + "static/img/banner.8115646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/industrial/banner.png
// module id = xrVK
// module chunks = 11